// import styled from "@emotion/styled";
import { UserForm } from "@curefit/cf-formservice";
import React from "react";

export interface CfFormProps {
  show: boolean;
  formPageResponse: any;
  formUserResponse: any;
  triggerAction: (action: any) => void;
  sendUserResponse: (response: any) => void;
  templateView: string;
  isDisabled?: boolean;
}

const checkIsSingleScreen = (formObj: any) => {
  return (
    formObj.renderOptionsMeta &&
    formObj.renderOptionsMeta.screenLayout === "SINGLE_SCREEN"
  );
};
export const CfForm: React.FunctionComponent<CfFormProps> = (props) => {
  const {
    show,
    formPageResponse,
    formUserResponse,
    triggerAction,
    sendUserResponse,
    templateView,
    isDisabled,
  } = props;

  if (show) {
    const isSingleScreen = checkIsSingleScreen(formPageResponse);
    return (
      <UserForm
        isSingleScreen={isSingleScreen}
        formPageResponse={formPageResponse}
        formUserResponse={formUserResponse}
        triggerAction={triggerAction}
        sendUserResponseToServer={sendUserResponse}
        templateView={templateView}
        isDisabled={isDisabled}
      />
    );
  }
  return null;
};
